module.exports = __webpack_public_path__ + "img/24.14b0a93f.jpg";